import SeederIcon from './SeederIcon'

export default SeederIcon
